// src/components/CookieBanner/CookieBanner.js
import { useState, useEffect } from 'react';
import './CookieBanner.css';

// Événement permettant de rouvrir la fenêtre de choix depuis n'importe où
// (lien « Gérer mes préférences » du pied de page). Le RGPD impose que le
// consentement puisse être retiré aussi facilement qu'il a été donné.
export const EVENEMENT_OUVRIR_COOKIES = 'bdk:ouvrir-preferences-cookies';

export function ouvrirPreferencesCookies() {
  window.dispatchEvent(new CustomEvent(EVENEMENT_OUVRIR_COOKIES));
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('bdk_cookies');
    if (!consent) setVisible(true);

    // Réouverture à la demande, depuis le pied de page
    function reouvrir() {
      setVisible(true);
      setShowDetails(true);
    }
    window.addEventListener(EVENEMENT_OUVRIR_COOKIES, reouvrir);
    return () => window.removeEventListener(EVENEMENT_OUVRIR_COOKIES, reouvrir);
  }, []);

  function enregistrer(analytics) {
    localStorage.setItem(
      'bdk_cookies',
      JSON.stringify({ necessary: true, analytics, date: new Date().toISOString() })
    );
    setVisible(false);
    setShowDetails(false);
  }

  const acceptAll  = () => enregistrer(true);
  const refuseAll  = () => enregistrer(false);

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Gestion des cookies">
      <div className="cookie-banner__inner">

        <div className="cookie-banner__content">
          <h3 className="cookie-banner__titre">Nous respectons votre vie privée</h3>
          <p className="cookie-banner__text">
            Le site Les Bazars de Keassa utilise uniquement des données strictement
            nécessaires à son fonctionnement : votre session, votre panier et vos
            préférences. Aucun traceur publicitaire ni outil de mesure d'audience
            n'est installé à ce jour. Si un outil de mesure venait à être ajouté,
            il ne serait activé qu'avec votre consentement explicite.
          </p>

          {showDetails && (
            <div className="cookie-banner__details">
              <div className="cookie-banner__detail-item">
                <div className="cookie-banner__detail-head">
                  <span className="cookie-banner__detail-name">Données nécessaires</span>
                  <span className="cookie-banner__detail-tag cookie-banner__detail-tag--always">Toujours actives</span>
                </div>
                <p className="cookie-banner__detail-desc">
                  Session de connexion, contenu du panier et mémorisation de ce choix.
                  Conservées dans votre navigateur, indispensables au fonctionnement
                  du site, et exemptées de consentement à ce titre.
                </p>
              </div>
              <div className="cookie-banner__detail-item">
                <div className="cookie-banner__detail-head">
                  <span className="cookie-banner__detail-name">Mesure d'audience</span>
                  <span className="cookie-banner__detail-tag">Non installée</span>
                </div>
                <p className="cookie-banner__detail-desc">
                  Aucun outil de statistiques n'est actif sur le site. Votre choix est
                  enregistré dès maintenant : si une mesure d'audience est mise en place,
                  elle respectera la préférence exprimée ici.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="cookie-banner__actions">
          <button className="btn-or cookie-banner__btn" onClick={acceptAll}>
            Tout accepter
          </button>
          <button className="btn-outline cookie-banner__btn" onClick={refuseAll}>
            Tout refuser
          </button>
          <button className="cookie-banner__link" onClick={() => setShowDetails(d => !d)}>
            {showDetails ? 'Masquer les details' : 'Personnaliser'}
          </button>
        </div>

      </div>
    </div>
  );
}